import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import './assets/css/global.css'
import './plugins/element.js'
// import echarts from 'echarts'

// px2rem 自适应
// import 'lib-flexible'

import dataV from '@jiaminghi/data-view'
Vue.use(dataV)

// Vue.prototype.$echarts = echarts
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

// // 大屏自适应
// function setRem() {
//   const baseSize = 80 // 1rem = 100px
//   const scale = document.documentElement.clientWidth / 1920
//   document.documentElement.style.fontSize = baseSize * scale + 'px'
// }
// window.onresize = setRem
// setRem()
